<ng-container *transloco="let t">

  <ng-container *ngrxLet="isProductContext$; let isProductContext">

    <ng-container *ngrxLet="isXs$; let isXs">

      <div class="d-flex flex-column flex-fill">

        <p class="mt-0 price-group d-inline">

        <span [innerHTML]="hasMoreVariants?t('price-from', {value:price}):price"
              class="price body-2 mb-0 mb-sm-2"></span>

          <ng-container *ngIf="listPrice">
            <span [innerHTML]="listPrice" class="list-price mat-caption ml-2"></span>
          </ng-container>

        </p>

        <div
          [class.flex-column]="isXs && !isProductContext"
          [class.justify-content-start]="isXs && !isProductContext"
          [class.align-items-start]="isXs && !isProductContext"
          [class.justify-content-between]="(isXs && isProductContext) || !isXs"
          [class.align-items-center]="(isXs && isProductContext) || !isXs"
          class="d-flex">

          <p class="m-0 mt-n1">
            <small [innerHTML]="title" class="caption"></small>
          </p>

          <app-quantity
            class="mt-2 mb-2 mt-sm-0 mb-sm-0"
            [hasMoreVariants]="hasMoreVariants"
            [variation]="resourceIdentifier"
            [quantity]="quantity$|async">
          </app-quantity>

        </div>

      </div>

    </ng-container>

  </ng-container>

</ng-container>
